import React from 'react';
import styles from './ConsumptionIndexMiniView.module.scss';

export interface ConsumptionIndexMiniViewProps {
  consumptionIndexValue: number | undefined;
  formattedConsumptionIndex: string;
  consumptionIndexStatus: 'ok' | 'warning' | 'danger';
  deviceId?: string;
  consumptionIndexTime?: string;
}

export default function ConsumptionIndexMiniView({
  consumptionIndexValue,
  formattedConsumptionIndex,
  consumptionIndexStatus,
  deviceId,
  consumptionIndexTime
}: ConsumptionIndexMiniViewProps) {
  const getStatusColor = () => {
    // Si c'est "NA", retourner gris très clair
    if (formattedConsumptionIndex === 'NA') {
      return '#d1d5db'; // Gris très clair
    }
    
    switch (consumptionIndexStatus) {
      case 'ok':
        return '#059669'; // Vert
      case 'warning':
      case 'danger':
        return '#dc2626'; // Rouge
      default:
        return '#059669';
    }
  };

  const statusColor = getStatusColor();
  const isNA = formattedConsumptionIndex === 'NA';
  
  // Construire le tooltip avec les informations disponibles
  const tooltipText = [
    deviceId && `ID: ${deviceId}`,
    `Index de consommation: ${formattedConsumptionIndex}${isNA ? '' : ' kWh'}`,
    consumptionIndexTime && `Capturé le: ${new Date(consumptionIndexTime).toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })}`
  ].filter(Boolean).join('\n');

  return (
    <div className={styles.consumptionIndexMini} title={tooltipText || undefined}>
      <span className={styles.consumptionIndexValue} style={{ color: statusColor }}>
        {formattedConsumptionIndex}
      </span>
      {!isNA && (
        <span className={styles.consumptionIndexUnit} style={{ color: statusColor }}>
          {' '}kWh
        </span>
      )}
    </div>
  );
}

